import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBuildingOutline = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14 7.5V14H4V7.5L9 4L14 7.5ZM5.5 8.28027V12.5H12.5V8.28027L9 5.83008L5.5 8.28027Z",
		fill: "currentColor"
	})
});
export default SvgBuildingOutline;
